import cloneDeep from "lodash/cloneDeep";
import omit from "lodash/omit";

export default function speakingConvertToUploadFormat(task, { isNew }) {
    task = cloneDeep(task);

    delete task?.background_image_2;

    task.items = task.items.map(item => {
        if (item.image_id === null)
            delete item.image_id;

        item.backups = item?.backups?.map(backup => omit(backup, 'item_id'));
        item.answers = item?.answers?.map(a => {
            if (['MESSAGE', 'DIFFERENCE'].includes(item.item_type) && a?.image_id === '') {
                delete a.image_id;
            }
            if (!a?.coordinates?.top && !a?.coordinates?.left)
                delete a.coordinates;

            return a;
        });
        return item;
    })

    return task;
};